import React, { useEffect, useState, useRef } from 'react'
import { useParams, useHistory, useLocation } from 'react-router-dom'

import {
  HttpService,
  API,
  Title,
  toast,
  SimpleReactValidator,
  Common,
  Permissionkeys,
  DateFormat
} from '../../config/react'
import Spinner from '../Spinner'
const OrdersDetails = () => {
  const urlParams = useParams()
  const history = useHistory()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const FilterName = queryParams.get('name')
  const FilterStatus = queryParams.get('status')
  const FilterOrderNo = queryParams.get('ordernumber')
  const FilterEmail = queryParams.get('email')
  const FilterOrderFromDate = queryParams.get('orderfromdate')
  const FilterOrderToDate = queryParams.get('ordertodate')
  const FilterPage = queryParams.get('page')
  const validator = useRef(new SimpleReactValidator())
  const [IsAuth, setIsAuth] = useState(false)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [OrderDetailsList, setOrderDetailsList] = useState([])
  const [OrderStatusList, setOrderStatusList] = useState([])
  const [BillingAddressList, setBillingAddressList] = useState([])
  const [ShippingAddressList, setShippingAddressList] = useState([])
  const [ProductDetailsList, setProductDetailsList] = useState([])
  const [RefundAmountError, setRefundAmountError] = useState('')
  const textInput = React.useRef()
  const [checked, setChecked] = useState(false)
  const [selectedValue, setSelectedValue] = useState('')
  const [selectedStatus, setSelectedStatus] = useState('')
  const [ShippingType, setShippingType] = useState([])
  //  const [myValue, setMyValue] = useState('');
  const [Inputs, setInputs] = useState({
    id: 0,
    refund_type: 'full',
    refund_amount: '',
    tracking_number: '',
    shipping_type: '',
    DeliveryDate: ''
  })

  useEffect(() => {
    if (!Common.validatePermission(Permissionkeys.Products)) {
      history.push('/')
    }
    setIsAuth(true)
    setForceUpdate(!isForceUpdate)
    document.title = Title.OrdersDetails
    GetShippingRateList()
    GetOrderDetailsList()
  }, [urlParams.id])

  const GetShippingRateList = () => {
    const param = {
      page: 1,
      search: '',
      page_size: 50,
      sort_column: '',
      sort_direction: ''
    }

    HttpService.postApi(API.GetShippingRate, param).then((response) => {
      try {
        setShippingType(response.data.result[1])
      } catch (error) {
        console.error(error)
      }
    })
  }

  const GetOrderDetailsList = () => {
    const param = {
      OrderNumber: urlParams.id
    }
    HttpService.postApi(API.GetOrderDetail, param).then((response) => {
      const data = response.data.result[0][0]
      const addresses = Common.GetJSON(data.addresses)
      let productlist = data.products
      productlist = Common.GetJSON(productlist)
      productlist.sort((a, b) => a.id - b.id)
      productlist?.map((item) => {
        item.product_options = JSON.parse(item.product_options)
        return true
      })

      setOrderDetailsList(data)

      setProductDetailsList(productlist)
      if (addresses !== null) {
        setBillingAddressList(addresses[0])
        setShippingAddressList(addresses[1])
      }
      // Inputs['status'] = data.order_status
      setSelectedValue(data.order_status_id)
      if (OrderDetailsList.remaining_refund_amount !== null) {
        setInputs({ ...Inputs, refund_amount: OrderDetailsList.remaining_refund_amount ?? 0 })
      } else {
        setInputs({ ...Inputs, refund_amount: OrderDetailsList.order_total ?? 0 })
      }
      setForceUpdate(!isForceUpdate)
      if (data.shipping_method) {
        setInputs({ ...Inputs, shipping_type: data?.shipping_method })
      }
      GetOrderStatusList(data.order_status_id)
      if (data.order_status === 'SHIPPING') {
        setInputs({
          ...Inputs,
          shipping_type: data.shipping_method,
          tracking_number: data.order_tracking_number,
          DeliveryDate: new Date(data.delivery_date).toISOString().split('T')[0]
        })
        setForceUpdate(!isForceUpdate)
      }
    })
  }

  const GetOrderStatusList = (statusId) => {
    HttpService.getApi(API.GetOrderStatusList).then((response) => {
      const data = response.data.result
      const status = data.filter((x) => x.id === statusId)[0]
      for (let i = 0; i < data.length; i++) {
        if (
          data[i].id === status.id ||
          (data[i].status === 'CANCELLED' && status.status !== 'REFUNDED')
        ) {
          data[i].is_disable = false
        } else {
          data[i].is_disable = true
        }
      }
      if (status.status === 'PENDING') {
        data.filter((x) => x.status === 'CONFIRMED')[0].is_disable = false
      } else if (status.status === 'CONFIRMED') {
        data.filter((x) => x.status === 'INPROCESS')[0].is_disable = false
      } else if (status.status === 'INPROCESS') {
        data.filter((x) => x.status === 'ON HOLD')[0].is_disable = false
        data.filter((x) => x.status === 'COMPLETED')[0].is_disable = false
        // data.filter((x) => x.status === 'SHIPPING')[0].is_disable = false
      } else if (status.status === 'ON HOLD') {
        data.filter((x) => x.status === 'SHIPPING')[0].is_disable = false
      } else if (status.status === 'COMPLETED') {
        data.filter((x) => x.status === 'SHIPPING')[0].is_disable = false
        //  data.filter((x) => x.status === 'COMPLETED')[0].is_disable = false
      } else if (status.status === 'CANCELLED') {
        data.filter((x) => x.status === 'REFUNDED')[0].is_disable = false
      }
      setOrderStatusList(data)
      setSelectedStatus(status.status)
    })
  }

  const handleInputChanges = (prop) => (e) => {
    if (prop === 'status') {
      const value = parseInt(e.target.value)
      const status = OrderStatusList.filter((x) => x.id === value)[0]

      setSelectedStatus(status.status)
      setSelectedValue(e.target.value)
    } else if (prop === 'refund_type') {
      if (prop === 'refund_type' && e.target.value === 'partial') {
        setInputs({
          ...Inputs,
          [prop]: e.target.value,
          refund_amount: OrderDetailsList.remaining_refund_amount ?? 0
        })
      } else if (prop === 'refund_type' && e.target.value === 'full') {
        if (OrderDetailsList.remaining_refund_amount !== null) {
          setInputs({
            ...Inputs,
            [prop]: e.target.value,
            refund_amount: OrderDetailsList.remaining_refund_amount ?? 0
          })
        } else {
          setInputs({
            ...Inputs,
            [prop]: e.target.value,
            refund_amount: OrderDetailsList.final_price ?? 0
          })
        }
      }
    } else {
      setInputs({ ...Inputs, [prop]: e.target.value })
    }
    setForceUpdate(!isForceUpdate)
  }
  const UpdateOrderStatus = async (e) => {
    e.preventDefault()
    if (!validator.current.allValid()) {
      validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    }
    if (
      Inputs.refund_type === 'partial' &&
      parseFloat(Inputs.refund_amount) > OrderDetailsList.remaining_refund_amount
    ) {
      setRefundAmountError('Refund amount should not greater than remaining refund amount')
      return
    } else setRefundAmountError('')
    const OrderData = {
      _order_id: OrderDetailsList.id,
      order_number: OrderDetailsList.order_number,
      status: selectedValue,
      refund_type: Inputs.refund_type,
      refund_amount:
        Inputs.refund_type === 'partial'
          ? Inputs.refund_amount
          : OrderDetailsList.order_total - OrderDetailsList.total_refunded_amount,
      is_refund: selectedStatus === 'REFUNDED' ? 1 : 0,
      is_customer_notified: checked,
      comment: textInput.current.value,
      tracking_number: Inputs.tracking_number,
      shipping_method: Inputs.shipping_type,
      delivery_date: Inputs.DeliveryDate
    }
    HttpService.postApi(API.UpdateOrderStatus, OrderData).then((response) => {
      if (response.data.result) {
        toast.success(response.data.result)
        textInput.current.value = ''
        validator.current.hideMessages()
        setChecked(false)
        GetOrderDetailsList()
      }
    })
  }
  const handleBackClick = () => {
    history.push('/sales/orders', {
      state: {
        page: parseInt(FilterPage) === 0 ? 1 : parseInt(FilterPage),
        ordernumber: FilterOrderNo,
        ordertodate: FilterOrderToDate,
        email: FilterEmail,
        orderfromdate: FilterOrderFromDate,
        status: FilterStatus,
        name: FilterName
      }
    })
  }

  return !IsAuth ? (
    <Spinner />
  ) : (
    // <div>
    //     <div className="page-header">
    //         <h3 className="page-title"> {Title.OrdersDetails} </h3>

    //     </div>
    //     <div className="row">
    //         <div className="col-lg-12 grid-margin stretch-card">
    //             <div className="card">
    //                 <div className="card-body">
    //                     <button className="btn btn-primary btn-fw rounded filter-btn mr-2" onClick={e => UpdateOrderStatus(e)}>status</button>
    //                 </div>
    //             </div>
    //         </div>
    //     </div>
    // </div>
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title">{Title.OrdersDetails} </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={handleBackClick}
          >
            {' '}
            Back{' '}
          </button>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="row justify-content-between">
                <div className="col-md-12">
                  <div className="card-header p-0 pb-2 mb-3">
                    <h3 className="title font-20">Order & Account Information</h3>
                  </div>
                </div>

                <div className="col-md-5">
                  <div className="address-info">
                    <h4>Order {OrderDetailsList.order_number}</h4>
                    <table className="table table-striped table-borderless">
                      <tbody>
                        <tr>
                          <td className="text-left">Order Date</td>
                          {/* <td className="text-right">Jan 31, 2022, 7:07:01 PM</td>  */}
                          <td className="text-right">
                            <DateFormat value={OrderDetailsList.created_at} />
                          </td>
                        </tr>
                        <tr>
                          <td className="text-left">Order Status</td>
                          <td className="text-right">{OrderDetailsList.order_status}</td>
                        </tr>
                        {/* <tr>
                                                    <td>Purchased From</td>
                                                    <td  className="text-right"> </td>
                                                </tr>  */}

                        <tr>
                          <td className="text-left">Nivoda Order ID</td>
                          <td className="text-right">{OrderDetailsList.nivoda_order_id}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="address-info">
                    <h4>Account Information</h4>
                    <table className="table table-striped table-borderless">
                      <tbody>
                        <tr>
                          <td className="text-left">Customer Name</td>
                          <td className="text-right">
                            {BillingAddressList.firstname} {BillingAddressList.lastname}
                          </td>
                        </tr>
                        <tr>
                          <td className="text-left">Email</td>
                          <td className="text-right">
                            <a href={'mailto:' + OrderDetailsList.email}>
                              {OrderDetailsList.email}
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td className="text-left">Phone</td>
                          <td className="text-right">{OrderDetailsList.phone}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="row justify-content-between">
                <div className="col-md-12">
                  <div className="card-header p-0 pb-2 mb-3">
                    <h3 className="title font-20">Address Information</h3>
                  </div>
                </div>

                <div className="col-md-5">
                  <div className="address-info">
                    <h4>
                      Billing Address {/* <a href="#" className="edit-link font-13"> Edit</a> */}
                    </h4>
                    <p>
                      {BillingAddressList.firstname} {BillingAddressList.lastname}
                      <br></br>
                      {BillingAddressList.street} {BillingAddressList.city}
                      <br></br>
                      {BillingAddressList.state} {BillingAddressList.country}
                      <br></br>
                      Pin code : {BillingAddressList.postcode}
                      <br></br>
                    </p>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="address-info">
                    <h4>
                      Shipping Address {/* <a href="#" className="edit-link font-13"> Edit</a> */}
                    </h4>
                    <p>
                      {ShippingAddressList.firstname} {ShippingAddressList.lastname}
                      <br></br>
                      {ShippingAddressList.street} {ShippingAddressList.city}
                      <br></br>
                      {ShippingAddressList.state} {ShippingAddressList.country}
                      <br></br>
                      Pin code : {ShippingAddressList.postcode}
                      <br></br>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="row justify-content-between">
                <div className="col-md-12">
                  <div className="card-header p-0 pb-2 mb-3">
                    <h3 className="title font-20">Payment & Shipping Method</h3>
                  </div>
                </div>

                <div className="col-md-5">
                  <div className="address-info">
                    <h4>Payment Information</h4>
                    <p>{Common.GetPaymentMethod(OrderDetailsList.payment_method)}</p>
                    <p>The order was placed using {OrderDetailsList.currency_name}.</p>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="address-info">
                    <h4>Shipping & Handling Information</h4>
                    <p>
                      {/* <b>Marketplace Rates - Multi Shipping :</b> $5.00 */}
                      <b>Free</b>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="row justify-content-between">
                <div className="col-md-12">
                  <div className="card-header p-0 pb-2 mb-3">
                    <h3 className="title font-20">Items Ordered</h3>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="table-responsive">
                    <table className="table text-center">
                      <thead>
                        <tr>
                          <th>Product</th>
                          <th>Country/Size</th>
                          <th>SKU/Certificate</th>
                          {/* <th>System SKU</th> */}
                          <th>Price</th>
                          <th>Qty</th>
                          {/* <th>Tax Amount</th> */}
                          <th>Product Discount</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {ProductDetailsList?.map((item, index) => {
                          // const engraving =
                          //   item.engraving !== null ? JSON.parse(item.engraving) : []
                          return (
                            <tr key={index}>
                              <td>
                                {item.name}
                                {/* {item.vendor !== null ? (
                                  <span>
                                    {' ( Vendor : '} <b> {item.vendor} </b>
                                    {')'}
                                  </span>
                                ) : (
                                  <></>
                                )} */}
                                <br />
                                {!item.is_diamond ? (
                                  <>
                                    {
                                      <>
                                        {item.product_options
                                          .filter(
                                            (x) =>
                                              x.show_in_storefront === 1 && x.Is_standalone === 0
                                          )
                                          .map((x, index, filteredOptions) => (
                                            <span key={index}>
                                              {x.title}: <b>{x.value}</b>
                                              {index !== filteredOptions?.length - 1 &&
                                                (index + 1) % 3 !== 0 &&
                                                ', '}
                                              {(index + 1) % 3 === 0 && <br />}
                                            </span>
                                          ))}

                                        {item.stand_alone_attribute?.length > 0 &&
                                          item.stand_alone_attribute.map((item1) => {
                                            return (
                                              item1.Is_standalone === 1 && (
                                                <span key={item1.title}>
                                                  {', '}
                                                  {item1.attribute_name} :{' '}
                                                  <b>{item1.selected_value_label}</b>
                                                </span>
                                              )
                                            )
                                          })}
                                      </>
                                    }
                                  </>
                                ) : (
                                  ''
                                )}
                              </td>
                              {/* {engraving.text !== undefined ? (
                                <td>
                                  <b>Text:</b> {engraving.text}
                                  <br />
                                  <b>Font Style:</b> {engraving.font_style}
                                </td>
                              ) : (
                                <td>N/A</td>
                              )} */}
                              <td>
                                {item.is_diamond === 0 && item.size !== '0'
                                  ? item.country + ' - '
                                  : ''}

                                {item.is_diamond === 0 && item.size !== '0' ? item.size : '-'}
                              </td>
                              {/* <td>{item.parent_sku ? item.parent_sku : '-'}</td> */}

                              <td>
                                {item.is_diamond === 0
                                  ? item.sku
                                  : `${item.sku}${
                                      item?.product_options?.find((x) => x?.title === 'Certificate')
                                        ?.value
                                        ? ` / ${
                                            item.product_options.find(
                                              (x) => x?.title === 'Certificate'
                                            )?.value
                                          }`
                                        : ''
                                    }`}
                              </td>

                              <td>
                                {OrderDetailsList.symbol} {item.price}
                              </td>
                              <td>{item.qty}</td>
                              {/* <td>{OrderDetailsList.symbol}{item.tax_price}</td> */}
                              <td>
                                {OrderDetailsList.symbol}
                                {item.discount_amount}
                              </td>
                              <td>
                                {OrderDetailsList.symbol}
                                {item.final_price}
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="row justify-content-between">
                <div className="col-md-12">
                  <div className="card-header p-0 pb-2 mb-3">
                    <h3 className="title font-20">Order Total</h3>
                  </div>
                </div>
                {/* {console.log(selectedStatus)} */}
                <div className="col-md-5">
                  <div className="address-info">
                    {/* <h4>Notes for this Order</h4> */}
                    <form
                      className="mt-0"
                      onSubmit={UpdateOrderStatus}
                    >
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">
                          <strong>Status</strong>
                        </label>
                        <select
                          id="inputState"
                          className="form-control w-50"
                          value={selectedValue}
                          onChange={handleInputChanges('status')}
                        >
                          {OrderStatusList.map((status, index) => (
                            <option
                              key={index}
                              value={status.id}
                              hidden={status.is_disable}
                            >
                              {status.status}
                            </option>
                          ))}
                        </select>
                      </div>
                      {selectedStatus === 'SHIPPING' && (
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">
                                <strong>Shipping Type</strong>
                              </label>
                              <select
                                name="shipping_type"
                                className="form-control w-50"
                                value={Inputs.shipping_type}
                                onChange={handleInputChanges('shipping_type')}
                              >
                                {ShippingType.map((item, index) => (
                                  <option
                                    key={index}
                                    value={item.id}
                                  >
                                    {item.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">
                                <strong>Tracking Number</strong>
                              </label>
                              <input
                                type="text"
                                name="tracking_number"
                                value={Inputs.tracking_number}
                                className="form-control"
                                onChange={handleInputChanges('tracking_number')}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">
                                <strong>Delivery Date</strong>
                              </label>
                              <input
                                type="date"
                                className="form-control"
                                name="DeliveryDate"
                                min={new Date().toISOString().split('T')[0]}
                                onChange={handleInputChanges('DeliveryDate')}
                                value={Inputs.DeliveryDate}
                                placeholder="Delivery Date"
                              />
                            </div>
                          </div>
                        </div>
                      )}
                      {selectedStatus === 'REFUNDED' &&
                      OrderDetailsList.final_price !== OrderDetailsList.total_refunded_amount ? (
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label htmlFor="exampleInputEmail1">
                                <strong>Refund Type</strong>
                              </label>
                              <select
                                name="refund_type"
                                className="form-control w-50"
                                value={Inputs.refund_type}
                                onChange={handleInputChanges('refund_type')}
                                onBlur={() => validator.current.showMessageFor('refund_amount')}
                              >
                                <option value="full">Full</option>
                                <option value="partial">Partial</option>
                              </select>
                              {validator.current.message(
                                'Refund Type',
                                Inputs.refund_type,
                                'required',
                                { className: 'error' }
                              )}
                            </div>
                            {Inputs.refund_type === 'partial' ? (
                              <div className="form-group">
                                <label htmlFor="exampleInputEmail1">
                                  <strong>Refund Amount</strong>
                                </label>
                                <input
                                  type="number"
                                  name="refund_amount"
                                  step="1"
                                  min={1}
                                  value={Math.round(Inputs.refund_amount)}
                                  className="form-control"
                                  onChange={handleInputChanges('refund_amount')}
                                />
                                {validator.current.message(
                                  'Refund Amount',
                                  Inputs.refund_amount,
                                  Inputs.refund_type === 'partial' ? 'required' : '',
                                  { className: 'error' }
                                )}
                                <p className="error">{RefundAmountError}</p>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                      ) : (
                        ''
                      )}
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">
                          <strong>Comment</strong>
                        </label>
                        <textarea
                          type="text"
                          className="form-control"
                          ref={textInput}
                        ></textarea>
                      </div>
                      <div className="form-group form-check mb-2">
                        <input
                          type="checkbox"
                          className="form-check-input ml-0 checkbox"
                          id="exampleCheck1"
                          checked={checked}
                          onChange={(e) => setChecked(e.target.checked)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="exampleCheck1"
                        >
                          Notify Customer by Email
                        </label>
                      </div>
                      <div className="form-group">
                        <div className="btn-group">
                          <button className="btn btn-dark btn-fw rounded"> Submit </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="col-md-5">
                  <div className="address-info">
                    <table className="table table-striped table-borderless">
                      <tbody>
                        <tr>
                          <th className="text-left">Subtotal</th>
                          <th className="text-right">
                            {OrderDetailsList.symbol}
                            {OrderDetailsList.order_subtotal}
                          </th>
                        </tr>
                        <tr>
                          <td className="border-bottom text-left">Coupon Discount</td>
                          <td className="text-right border-bottom">
                            {OrderDetailsList.symbol}
                            {OrderDetailsList.discount_amount}
                          </td>
                        </tr>
                        <tr>
                          <td className="border-bottom bg-white text-left">Shipping</td>
                          <td className="text-right border-bottom bg-white">
                            {OrderDetailsList.symbol}
                            {OrderDetailsList.shipping_amount}
                          </td>
                        </tr>
                        <tr>
                          <td className="border-bottom text-left">
                            VAT/Tax ({OrderDetailsList.tax_percentage}%)
                          </td>
                          <td className="text-right border-bottom">
                            {OrderDetailsList.symbol}
                            {OrderDetailsList.tax_amount}
                          </td>
                        </tr>
                        {(OrderDetailsList.card_fee &&
                          OrderDetailsList.payment_method !== 'bank_transfer') > 0 && (
                          <tr>
                            <td className="border-bottom text-left">Card Fee</td>
                            <td className="text-right border-bottom">
                              {OrderDetailsList.symbol}
                              {OrderDetailsList.card_fee}
                            </td>
                          </tr>
                        )}
                      </tbody>
                      <tfoot>
                        <tr>
                          <th className="text-left">Grand Total</th>
                          <th className="text-right">
                            {OrderDetailsList.symbol}
                            {OrderDetailsList.final_price}
                          </th>
                        </tr>
                        <tr>
                          <th className="text-left">Total Paid</th>
                          <th className="text-right">
                            {OrderDetailsList.symbol}
                            {OrderDetailsList.final_price}
                          </th>
                        </tr>
                        <tr>
                          <th className="text-left">Total Refunded</th>
                          <th className="text-right">
                            {OrderDetailsList.symbol}
                            {OrderDetailsList.total_refunded_amount}
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OrdersDetails
